import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { CluGhostModeFnsDialogComponent } from "./clu-ghostmode-fns-dialog.component";
import { CluGhostModeFnsDialogService } from "./clu-ghostmode-fns-dialog.service";
import { TablerIconsModule } from "angular-tabler-icons";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [CluGhostModeFnsDialogComponent],
    imports: [
        CommonModule,
        TranslateModule,
        MaterialModule,
        TablerIconsModule,
        FormsModule,
    ],
    providers: [CluGhostModeFnsDialogService]
})
export class CluGhostModeFnsDialogModule {}